module.exports = __webpack_public_path__ + "img/background1.2135e842.png";